import {Component, inject} from '@angular/core';
import {NewsService} from "../../../news/services/news.service";
import {News} from "../../../news/models/news";
import {DatePipe} from "@angular/common";
import {RouterLink} from "@angular/router";
import {getTranslation} from "../../../core/models/translatable-model-abstract";
import {NewsListWrapper} from "../../../news/models/news-list-wrapper";

@Component({
  selector: 'app-contact-section',
  standalone: true,
  imports: [
    DatePipe,
    RouterLink
  ],
  templateUrl: './contact-section.component.html',
  styleUrl: './contact-section.component.scss'
})
export class ContactSectionComponent {
  private newsService = inject(NewsService);
  protected newsListWrapper: NewsListWrapper| null = null;

  constructor() {
    this.newsService.getListFromApi(1).subscribe({
        next: newsListRes => {
          this.newsListWrapper = newsListRes;
        },
      }
    );
  }

  protected readonly getTranslation = getTranslation;
}
